import { cssAnchorProps } from "@circle-react/helpers/cssAnchorHelpers";
import { MobileTopNav } from "@circleco/compass/components/MobileTopNav";

import { t } from "@/i18n-js/instance";

import { MobileLoggedOutAuthActions } from "./MobileLoggedOutAuthActions";

interface MobileLoggedOutTopBarProps {
  communityName: string;
  logoUrl: string | undefined;
}

/**
 * TopBar for unauthenticated visitors and signed-in non-members.
 * Shows community logo or name on the left, auth/join buttons on the right.
 *
 * - Logged-out users: Login + Join buttons
 * - Signed-in non-members: Join button only (Login hidden since they're
 *   already authenticated)
 */
export const MobileLoggedOutTopBar = ({
  communityName,
  logoUrl,
}: MobileLoggedOutTopBarProps) => {
  const primaryAction = <MobileLoggedOutAuthActions />;

  return logoUrl ? (
    <MobileTopNav
      logo={{
        src: logoUrl,
        alt: t("community_logo_alt", { community_name: communityName }),
        imgProps: {
          id: "community-logo",
          ...cssAnchorProps({ anchor: "app-topbar-logo-image" }),
        },
      }}
      primaryAction={primaryAction}
    />
  ) : (
    <MobileTopNav title={communityName} primaryAction={primaryAction} />
  );
};
